module.exports = __webpack_public_path__ + "static/media/checked.4190ac11.svg";